// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupTemplateThird_wrapper__1AXGs","box":"PopupTemplateThird_box__1smi8"};